import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { ItemCotizacionData } from '../../types';

interface ItemFormHeaderProps {
  item: ItemCotizacionData;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

/**
 * Componente para el header del formulario de item
 */
export const ItemFormHeader: React.FC<ItemFormHeaderProps> = ({
  item,
  isCollapsed,
  onToggleCollapse,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold', color: '#424242' }}
        >
          {item.nombreProducto}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
          Código: {item.codigoProducto} | Grupo: {item.grupoProducto}
        </Typography>
        <Typography variant="body2">BODEGA {item.nombreBodega}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {/* Unidades del item */}
        <Box
          sx={{
            bgcolor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            p: 1.5,
            minWidth: 120,
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
            Unidades
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: '#424242',
              fontSize: 16,
            }}
          >
            {item.totalUnidadesSolicitadas} UNDS
          </Typography>
        </Box>
        {/* Botón de colapsar */}
        <IconButton
          onClick={onToggleCollapse}
          sx={{ color: '#1976d2' }}
          aria-label={
            isCollapsed ? 'Expandir formulario' : 'Colapsar formulario'
          }
        >
          {isCollapsed ? <ExpandMore /> : <ExpandLess />}
        </IconButton>
      </Box>
    </Box>
  );
};

